import { localizeDate } from '@/utils/date';
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
export default {
  name: 'CoreConnectorsStatusLogs',
  props: {
    connectorId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isLoadingLogs: false,
      connectorLogs: [],
      logItemPayload: null,
      activeItemIndex: -1,
      lastRefreshed: null
    };
  },
  computed: {
    ...mapState('app', ['color']),
    hasNoPackets() {
      return this.connectorLogs.length === 0;
    }
  },
  mounted() {
    this.fetchConnectorLogs();
  },
  methods: {
    localizeDate,
    isJsonPayload(payload) {
      try {
        JSON.parse(JSON.stringify(payload));
      } catch (e) {
        return false;
      }
      return true;
    },
    getLogLevelColor(level) {
      switch (level) {
        case 'error':
          return 'danger';
        case 'warn':
          return 'warning';
        case 'info':
          return 'primary';
        default:
          return 'primary';
      }
    },
    getLogLevelIcon(level) {
      switch (level) {
        case 'error':
          return 'fa-exclamation-circle';
        case 'warn':
          return 'fa-exclamation-triangle';
        case 'info':
          return 'fa-info-circle';
        default:
          return 'fa-check-circle';
      }
    },
    handleItemSelected(item) {
      this.activeItemId = item.id;
      this.logItemPayload = item.payload;
    },
    fetchConnectorLogs() {
      this.isLoadingLogs = true;
      this.logItemPayload = null;
      ApiService.getBridgeLogs(this.connectorId).then(response => {
        this.lastRefreshed = new Date();
        this.connectorLogs = response;
        if (this.connectorLogs.length > 0) {
          this.handleItemSelected(this.connectorLogs[0]);
        }
      }).catch(error => {
        this.$snack(this.$i18n_t('Connectors.Connectors.statusLogs.error'), 'error');
        console.error(error);
      }).finally(() => {
        this.isLoadingLogs = false;
      });
    }
  }
};